import "./HalfUnderLinedText.scss";

export const HalfunderLinedText = ({
  text,
  type = 2,
}: {
  text: string;
  type?: 1 | 2;
}) => {
  return <span className={`textUnderlined type_${type}`}>{text}</span>;
};
